import { render, staticRenderFns } from "./qrNfcList.vue?vue&type=template&id=060feb2f"
import script from "./qrNfcList.vue?vue&type=script&lang=js"
export * from "./qrNfcList.vue?vue&type=script&lang=js"
import style0 from "./qrNfcList.vue?vue&type=style&index=0&id=060feb2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports